import styled from 'styled-components';
import mediaQuery from 'styles/mediaQuery';

export const PreviewContainer = styled.div`
  padding-bottom: 48px;

  .horizontal-radio-group {
    > div > div {
      flex-direction: row;
      gap: 18px;
      margin-top: 0px;
    }
  }
`;

export const PreviewDivider = styled.div`
  margin: 24px 0;
  height: 1px;
  background-color: #21252926;
`;

export const PreviewHeader = styled.header`
  h2 {
    font-size: 32px;
    font-weight: 300;
    line-height: 1.2em;
    margin: 0;
  }

  h3 {
    font-size: 16px;
    font-weight: 300;
    line-height: 1.2em;
    margin-top: 12px;
  }
`;

export const PreviewRow = styled.div<{
  columns?: number;
}>`
  display: grid;
  grid-template-columns: repeat(${({ columns }) => columns ?? 4}, 1fr);
  gap: 12px;

  ${mediaQuery.xs} {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const PrimaryGuestInfoContainer = styled.section`
  display: flex;
  flex-direction: column;
  gap: 16px;

  h2 {
    font-size: 18px;
    margin-top: 0;
    margin-bottom: 8px;
  }

  .form-group {
    > label,
    > div {
      padding: 0;
    }

    margin-bottom: 0px !important;
  }
`;

export const OtherGuestInfoContainer = styled(PrimaryGuestInfoContainer)`
  .checkbox {
    span {
      margin-right: 12px;
    }
  }
`;

export const OtherGuestFieldsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  h3 {
    font-size: 16px;

    margin: 8px 0;
  }
`;

export const ArrivalInfoContainer = styled(PrimaryGuestInfoContainer)``;

export const HouseRulesContainer = styled(PrimaryGuestInfoContainer)`
  .checkbox > label {
    margin-top: 12px;
  }
`;

export const AdditionalInfoContainer = styled(PrimaryGuestInfoContainer)``;
